import { IUser } from '../../modules/Auth/models/user.model';
import { loadScriptCubos } from './cubos';
import { loadScriptKira } from './kira';

const idsDisable: any = ['6021df41cdfa730e27e5f98a'];

export default function iaAssistant(user: IUser | null) {
  try {
    if (user && user.id && user.email && !idsDisable.includes(user.id)) {
      if (user && user.iaAssistant === 'external') {
        console.log('------ CUBOS --------');
        loadScriptCubos(user);
      } else if (user && user.iaAssistant === 'internal') {
        console.log('------ KIRA --------');
        loadScriptKira(user);
      }
    }
  } catch (e) {
    console.log('Error IA');
  }
}
